__turbopack_context__.v({
  "info": "LinkedAssetRows-module__7nK49q__info",
  "item": "LinkedAssetRows-module__7nK49q__item",
  "link": "LinkedAssetRows-module__7nK49q__link",
  "list": "LinkedAssetRows-module__7nK49q__list",
});
